
export default {
	data: () => ({
		brandsList: [
			{
				icon: "/static/images/ic_ft_ws.png",
				iconWidth: 26,
				iconHeight: 26,
				text: "Wordscapes Answers & Cheat",
				link: "https://wordscapes.yourdictionary.com",
			},
			{
				icon: "/static/images/ic_ft_cwh.png",
				iconWidth: 26,
				iconHeight: 26,
				text: "Crossword Helper",
				link: "https://crosswordhelper.com/",
			},
			{
				icon: "/static/images/ic_ft_wlf.png",
				iconWidth: 26,
				iconHeight: 26,
				text: "WordList Finder",
				link: "https://wordlistfinder.com/",
			},
			{
				icon: "/static/images/ic_ft_sis.png",
				iconWidth: 26,
				iconHeight: 26,
				text: "Simply Scrabble",
				link: "https://simplyscrabble.com/",
			},
			{
				icon: "/static/images/ic_wfw_header.png",
				iconWidth: 32,
				iconHeight: 20,
				text: "Buscador de Palabras",
				link: "https://es.yourdictionary.com/buscador-de-palabras/",
			},
			{
				icon: "/static/images/ic_ft_yd.png",
				iconWidth: 26,
				iconHeight: 26,
				text: "YourDictionary",
				link: "https://www.yourdictionary.com/",
			},
		],
	}),
};
